import React, { useState, useEffect, useRef } from "react";
import Page from '../Page.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import PageContentWrapper from "../../components/PageContentWrapper";
import { getApi } from "../../api/endpoints";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DetailsComponent from "../../components/DetailsComponent";
import SetUserBranch from "../../components/SetUserBranch";
import Multiselect from "multiselect-react-dropdown";
import HeadUser from '../../models/HeadUser';
import AreaUserMappingListing from '../area_user_mapping/Listing'
import { updateQueryParams, selectQueryParams } from "../../ui/customerListingReducer.js";
import { useSelector, useDispatch } from "react-redux";
import TabsComponent from "../../components/TabsComponent"
import ZoneMappingsListing from "../zone/user_mappings"
import CircleMappingsListing from "../circles/user_mappings"
import ClusterMappingsListing from "../clusters/user_mappings"

const MapUser = () => {
  const [fetchApi] = getApi('showUser');
  
  const params = useParams();
  const [tabs, setTabs] = useState([])
  let headUserObj = new HeadUser({});
  const [headUser, setHeadUser] = useState(headUserObj.toStateJson());
  const selectedQueryParams = useSelector(selectQueryParams);
  const [usersTypes , setUsersTypes] = useState([]);
  const [userBranch, setUserBranch] = useState(null);
  
  const [usersTypesApi] = getApi('usersTypes');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    getRecord({ id: params.id });
    fetchUsersTypes();
  }, []);

  useEffect(() => {
    setUpTabsComponent();
  }, [headUser])

  const setUpTabsComponent = () => {
    let calc_tabs = new Set()
    let area_head_or_fso = false
    headUser?.user_roles?.forEach((role)=>{
      switch(role.users_type_id) {
        case 1:
        case 25: // fso
          if(area_head_or_fso) break;
          area_head_or_fso = true
          calc_tabs.add({
            event: 'pincode_map',
            heading: 'Pincodes Map',
            component: <AreaUserMappingListing branch_id={headUser.branch_id}/>,
            ui_action: 'view_area_mapping'
          })
          break;
        case 18: // zonal head
          calc_tabs.add({
            event: 'zone_map',
            heading: 'Zones Map',
            component: <><ZoneMappingsListing zones={headUser.zones}/></>,
            ui_action: 'view_zonal_mapping'
          })
          break;
        case 10: // cluster_head
          calc_tabs.add({
            event: 'cluster_map',
            heading: 'Cluster Map',
            component: <><ClusterMappingsListing clusters={headUser.clusters} /></>,
            ui_action: 'view_cluster_mapping'
          })
          break
        case 11: // circle_head
          calc_tabs.add({
            event: 'circle_map',
            heading: 'Circle Map',
            component: <><CircleMappingsListing branches={headUser.circles}/></>,
            ui_action: 'view_circle_mapping'
          })
          break
        default:
      }
    })
    setTabs(Array.from(calc_tabs))
  }

  const getRecord = async (params) => {
    try {
      let response = await fetchApi(params).unwrap();
      headUserObj.setApiData(response.data.user);
      setUserBranch(headUserObj?.branch_id);
      setHeadUser(headUserObj.toStateJson());
    } catch (error) {
      toast.error(error?.data?.message || "Something went wrong while fetching user details.")
    }
  }

  const fetchUsersTypes = async () => {
    try {
      const response = await usersTypesApi({ filters: { mappable_users_types: true }}).unwrap();
      setUsersTypes(response.data.users_types.map(users_type => users_type.id));
    } catch (error) {
      toast.error(error.message || "Something went wrong while mapping user.")
    }
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.MapHeadUserPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Head Users", url: '/manage_users' }, { label: "Map Head User" }]}
    className={'map-head-user-page'}
  >
    <PageContentWrapper contentHeading={"Head User"}>
      <DetailsComponent data={headUserObj.detailsComponentData(headUser)} rowCount={4}/>
        <TabsComponent data={tabs}/>
    </PageContentWrapper>
  </Page>
}

export default MapUser;
